import React, { Fragment } from 'react';
import { FooterUserInfoColumn } from '../footerUserInfoColumn/index.js';

var UserBalanceAndTotalBetAmount = function (_a) {
    var label = _a.label, value = _a.value, currency = _a.currency;
    return (React.createElement(Fragment, null,
        React.createElement(FooterUserInfoColumn.Span, { text: label, isDarkTest: true }),
        React.createElement(FooterUserInfoColumn.P, null,
            React.createElement(FooterUserInfoColumn.Span, { text: value, isMoneyText: true }),
            React.createElement(FooterUserInfoColumn.Span, { text: currency }))));
};

export { UserBalanceAndTotalBetAmount };
